import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import './HashtagModal.scss'
import CustomButton from '../../UI/Buttons/CustomButton'
import TextInput from '../../UI/Inputs/TextInput'
import TextAreaInput from '../../UI/Inputs/TextAreaInput'
import GeneralForm from '../../Form'
import { FormikHelpers } from 'formik'
import { useDispatch, useSelector } from '../../../store'
import CustomPopup from '../../UI/Popup'
import { toggleHastagModalAction } from '../../../store/application/slice'
import { TOAST_MESSAGE } from '../../UI/ToastNotification/ToastNotification'
import { isFulfilled, isRejected } from '@reduxjs/toolkit'
import { useToasts } from 'react-toast-notifications';
import { resetEditHashAction } from '../../../store/hashtag/slice'
import { updateHashtagThunk, addHashtagThunk } from '../../../store/hashtag/thunks'

interface HashtagModalProps { }

function HashtagModal(props: HashtagModalProps) {
    const dispatch = useDispatch()
    const { addToast } = useToasts()

    const {
        inProgress,
        isOpenHashtagSetting,
        editHashtag,
        projectId
    } = useSelector((state) => ({
        inProgress: state.hashtag.inProgress,
        isOpenHashtagSetting: state.app.isOpenHashtagSetting,
        editHashtag: state.hashtag.editHashtag,
        projectId: state.project.currentProject.id
    }))


    const close = () => {
        dispatch(resetEditHashAction())
        dispatch(toggleHastagModalAction())
    }

    const setUpForm = {
        initialValues: {
            pool_name: editHashtag.pool_name || "",
            hashtag_pool_id: editHashtag.id || 0,
            hashtags: editHashtag.hashtags || "",
            project_id: projectId
        },
        enableReinitialize: true,
        validation: 'hashtag',
        onSubmit: async (values: any, actions: FormikHelpers<any>) => {
            let response;
            if (editHashtag.id === 0) {
                response = await dispatch(addHashtagThunk(values))
            } else {
                response = await dispatch(updateHashtagThunk(values))
            }
            if (isFulfilled(response)) {
                close()
                addToast(TOAST_MESSAGE.HASH_UPDATED, { appearance: 'success' })
            }else{
                const err:any = response;
                addToast(err.payload?.error?.message?err.payload.error.message:TOAST_MESSAGE.GENERAL_ERROR_MASSEGE, { appearance: 'error' })
            }
        }
    }

    return (
        <>
            <CustomPopup
                open={isOpenHashtagSetting}
                buttonClose={close}
                closeOnDocumentClick={false}
                className='hashtag-modal'
            >
                <div className='hashtag-modal__wrapper'>
                    <div className='hashtag-modal__header'>Create New Pool</div>
                    <div className='hashtag-modal__body'>
                        <GeneralForm {...setUpForm}>
                            <TextInput label='Pool Name' name='pool_name' placeholder='Enter pool name' />
                            <TextAreaInput minRows={8}
                                name='hashtags'
                                placeholder='Enter hashtags here'
                                style={{color:'#5E93C5'}}
                            />
                            <div className='hashtag-modal__actions'>
                                <CustomButton onClick={close} type='button' button='secondary' className='mr-2'>
                                    Cancel
                                </CustomButton>
                                <CustomButton inProgress={inProgress} button='primary' type='submit' className='ml-2'>
                                    Save
                                </CustomButton>
                            </div>
                        </GeneralForm>
                    </div>
                </div>
            </CustomPopup>
        </>
    )
}

export default HashtagModal
